import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useAgyleConfigStyles} from '../agyle_configuration';
import {externalConfigs, saveExternalConfigs} from '../../../store/reducers/externalConfig';
import * as React from 'react';
import {useEffect, useState} from 'react';
import _ from 'lodash';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import {Paper} from '@mui/material';
import TimeConfigurationCleaningRequest from './components/timeConfigurationCleaningRequest';
import LocationConfigurationCleaningRequest from './components/locationConfigurationCleaningRequest';
import TriggersConfigurationCleaningRequest from './components/triggersConfigurationCleaningRequest';
import WardManageConfigurationCleaningRequest from './components/wardManageConfigurationCleaningRequest';

const BedCleaningRequestCfg = ({context}) => {
    const classes = useAgyleConfigStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    // Config state
    const cfgs = useSelector(externalConfigs);
    const [savedConfig, setSavedConfig] = useState(null);

    const [switchValue, setSwitchValue] = useState('time');

    useEffect(() => {
        const find = _.find(cfgs, cfg => cfg.configType === context?.id);
        if (find) setSavedConfig(find);
    }, [cfgs]);

    const renderContext = () => {
        switch (switchValue) {
            case 'time':
                return <TimeConfigurationCleaningRequest
                    cfg={savedConfig}
                    handleSaveConfig={handleSaveConfig}
                />;
            case 'location':
                return <LocationConfigurationCleaningRequest
                    cfg={savedConfig}
                    handleSaveConfig={handleSaveConfig}
                />;
            case 'triggers':
                return <TriggersConfigurationCleaningRequest
                    cfg={savedConfig}
                    handleSaveConfig={handleSaveConfig}
                />;
            case 'manage':
                return <WardManageConfigurationCleaningRequest
                    cfg={savedConfig}
                    handleSaveConfig={handleSaveConfig}
                />;
            default:
                return null;
        }
    };

    const handleSaveConfig = (type, data) => {
        let value = savedConfig?.value ? _.cloneDeep(savedConfig?.value) : {};
        value[type] = data;

        const objToSave = {
            __id: savedConfig?.__id || null,
            description: context.description,
            configType: context.id,
            active: true,
            value,
        };
        dispatch(saveExternalConfigs(objToSave));
    };

    return (
        <>
            <AgyleBlockSwitch
                onChange={setSwitchValue}
                value={switchValue}
                nullState
                fourCases
                label="Show only trusted devices"
                valueObject={{
                    'true': 'time',
                    'null': 'triggers',
                    'alt': 'location',
                    'false': 'manage',
                }}
                customLabels={{
                    yes: t('Time Configuration'),
                    empty: t('Triggers'),
                    alternative: t('Locations'),
                    no: t('Ward as Manage by'),
                }}
            />

            <Paper className={classes.paper} style={{marginTop: 10}}>
                {renderContext()}
            </Paper>
        </>
    );
};

export default BedCleaningRequestCfg;